var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"tags pointer",style:({ backgroundColor: _vm.color }),attrs:{"to":this.tagItem.model === 'label' ?
        '/search?q=' + this.tagItem.name :
        '/search?selectedSubcategories=' + this.tagItem.id}},[_vm._v("\n    "+_vm._s(_vm.tagItem.name)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }